import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class upgradeState extends baseState {
  @observable list = {};
  @action
  setList = data => this.list = data;
  getList = data => {
    return this.fetch({
      url: apiUrl.UPGRADE.LIST,
      method: 'get',
      setState: this.setList,
      data,
    });
  }

  add = data => {
    return this.fetch({
      url: apiUrl.UPGRADE.ADD,
      data,
    });
  }

  del = id => {
    return this.fetch({
      url: apiUrl.UPGRADE.DEL + id,
      data: { id },
    });
  }

  analysisUrl = data => {
    return this.fetch({
      url: apiUrl.UPGRADE.ANALYSIS,
      method: 'get',
      data,
    });
  }

}
